import { useState } from "react";

export const useDialog = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const close = () => {
    setIsOpen(false);
  };
  const open = () => {
    setIsOpen(true);
  };

  return { close, isOpen, open };
};
